<template>
  <div class="cat-list">
    <div class="drap_down">
      <i class="nav_icon"></i>
      <span class="hidden-title">{{TLang('图书分类','my')}}</span>
    </div>
    <div
      ref="$listwrap"
      class="list-wrap"
      :class="{showMoreHeigth: showMore}"
      @mouseleave.prevent="showMore = false; activeItem = null"
    >
      <div
        v-for="cat in catList"
        :key="cat.id"
      >
        <div
          :class="{'drap_down_item': true, active: activeItem && activeItem.id === cat.id}"
          @mouseenter="(e) => {hoverItem(cat,e)}"
          @click="
            onChange(cat.id,cat,1);
          "
        >
          <img
            :src="cat.imgUrl"
            alt
          />
          <span>{{ cat.name }}</span>
        </div>
      </div>
      <div
        v-if="activeItem && activeItem.subCategoryList && activeItem.subCategoryList.length"
        ref="$rigth_content"
        class="rigth_content"
        :style="{top: right_content_top + 'px'}"
        @mouseleave.stop="activeItem = null"
      >
        <p
          @click="
            onChange(activeId,activeItem,1);
            activeItem = null;
          "
        >
          {{ activeItem.name }}
        </p>
        <div class="sub-list">
          <div
            v-for="goods in activeItem.subCategoryList"
            :key="goods.id"
            class="sub3-item"
            @click="
              onChange(goods.id,goods,1);
              activeItem = null;
            "
          >
            {{ goods.name }}
          </div>
        </div>
      </div>
      <div
        v-if="catList.length > 10 && !showMore"
        class="showMore"
        @click="showMore = true"
      >
        <i class="icon iconfont up">&#xe657;</i>
        <i class="icon iconfont down">&#xe657;</i>
        {{TLang('查看更多','my')}}
      </div>
    </div>
  </div>
</template>

<script>
import { unionFlag } from '@utils';
export default {
  props: {
    catList: {
      type: Array,
      default: function(){
        return [];
      },
    },
    onChange: Function,
  },
  data(){
    return {
      showMore: false,
      activeItem: {},
      activeId: null,
      union: unionFlag(),
      right_content_top: 0,
    };
  },
  methods: {
    hoverItem(cat,e){
      if(this.$refs.$rigth_content){
        if(e.target.offsetTop + this.$refs.$rigth_content.offsetHeight > this.$refs.$listwrap.offsetHeight){
          this.right_content_top = this.$refs.$listwrap.offsetHeight - this.$refs.$rigth_content.offsetHeight;
        }else {
          this.right_content_top = e.target.offsetTop;
        }
      }
      this.cateList = [];
      if (cat.name && cat.id) {
        this.activeTitle = cat.name;
        this.activeId = cat.id;
        this.activeItem = cat;
      }
    },
  },
};
</script>

<style lang="less">
.cat-list{
  width: 220px;
  margin-top: -44px;
  position: relative;
  margin-left: 20px;
  .drap_down{
    width: 220px;
    background: url('./bookNavBg.png') center center no-repeat;
    background-size: 100% auto;
    font-size: 16px;
    color: rgba(255, 255, 255, 1);
    text-align: left;
    line-height: 44px;
    display: flex;
    justify-content: left;
    align-items: center;
    padding-left: 52px;
    box-sizing: border-box;
    .nav_icon{
      width: 16px;
      height: 14px;
      margin-right: 10px;
      background: url('./navIcon.png') center center no-repeat;
      background-size: 100% auto;
    }
  }
  .list-wrap{
    height: 455px;
    box-shadow:0px 0px 16px 0px rgba(0,0,0,0.1);
    position: relative;
    // overflow-y: scroll;
    // max-height: 60vh;
    .drap_down_item {
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        display: flex;
        padding-left: 15px;
        padding-right: 10px;
        align-items: center;
        position: relative;
        white-space: nowrap;
        // background:rgba(243,243,243,1);
        height: 45px;
        line-height: 44px;
        img {
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }
        i {
          transform: rotate(90deg);
          margin-left: auto;
          font-size: 20px;
        }
        span {
          margin-left: 12px;
        }
        &::after {
          content: "";
          display: inline-block;
          height: 1px;
          width: 100%;
          background: #f7f7f7;
          position: absolute;
          bottom: 0;
          left: 0;
        }
        &:hover{
          background: #ECF5FD;
          color: #3D96E2;
          font-weight: bold;
          cursor: pointer;
          &:after {
            background:#ECF5FD;
          }
        }
      }
      .rigth_content{
        display: block;
        left: 100%;
        position: absolute;
        z-index: 11;
        top: 0px;
        width: 680px;
        background: #fff;
        padding: 30px;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
        height: auto;
        &:hover{
          cursor: pointer;

        }
        p {
          font-size: 18px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: left;
          position: relative;
          &:after {
            content: "";
            display: inline-block;
            width: 630px;
            height: 1px;
            background: #f0f0f0;
            position: absolute;
            bottom: -10px;
            left: 0;
          }
        }
          .sub-list {
            display: flex;
            flex-wrap: wrap;
            font-size: 12px;
            color: rgba(51, 51, 51, 1);
            max-height: 300px;
            overflow-y: scroll;
            margin-top: 26px;
            .sub3-item {
              margin-right: 20px;
              margin-bottom: 10px;
            }
            .sub3-item:hover {
              font-size: 12px;
              // font-weight: bold;
              color: rgba(61, 150, 226, 1);
              cursor: pointer;
            }
          }
      }
      .showMore{
        position: absolute;
        bottom: 0;
        text-align: center;
        width: 100%;
        height:44px;
        background:linear-gradient(180deg,rgba(255,255,255,0) 0%,rgba(255,255,255,0.8) 61%,rgba(255,255,255,1) 100%);
        line-height: 44px;
        color: #3D96E2;
        i{
          position: absolute;
          left: 62px;
          transform: rotate(180deg);
        }
        i.down{
          top: 3px;
        }
        i.up{
          top: -2px;
        }
        &:hover{
          cursor: pointer;
        }
      }
    }

    .showMoreHeigth{
      height: auto;
      overflow-y: visible;
    }
  }
</style>